import axios from '@util/axios'

export const BillingManagementService = {
  getBillingList: (companyId, options = {}) =>
    axios({
      ...options,
      url: `/company/${companyId}/billing/`,
    }),

  getAllBillingList: (options = {}) =>
    axios({
      ...options,
      url: `/company/billing/all/`,
    }),

  updateBilling: (companyId, { tpaCompanyId, billingStatus, billingStartPeriod }, options = {}) =>
    axios({
      ...options,
      url: `/company/${companyId}/billing/update/`,
      method: 'POST',
      data: {
        tpa_company_id: tpaCompanyId,
        billing_status: billingStatus,
        billing_start_period: billingStartPeriod || null,
      }
    }),

  bulkUpdateBilling: (companyId, { enable, billingStartPeriod, updates }, options = {}) =>
    axios({
      ...options,
      url: `/company/${companyId}/billing/bulk-update/`,
      method: 'POST',
      data: {
        enable: enable,
        billing_start_period: billingStartPeriod || null,
        updates: updates,
      }
    }),

  // Ensures a CompanyBilling row exists (billing_status=false) for an
  // underwriter/TPA pair a BDX edit just linked together. Server-side
  // get_or_create - idempotent, never touches an already-configured pair.
  ensureBilling: (underwriterCompanyId, tpaCompanyId, options = {}) =>
    axios({
      ...options,
      url: `/company/billing/ensure/`,
      method: 'POST',
      data: {
        company_underwriter_id: underwriterCompanyId,
        company_tpa_id: tpaCompanyId,
      }
    }),

  // Billing *type* - which scheme an underwriter bills under. One scheme per
  // call, so Market and LIMOSS stay independent and a failure on one cannot
  // leave the other half-applied. Superuser only, enforced server-side.
  importSlipShares: (file) => {
    const form = new FormData()
    form.append('file', file)
    // Content-Type is left unset on purpose: the browser has to add the
    // multipart boundary, and naming the type here strips it.
    return axios({
      url: `/slip-share/import/`,
      method: 'POST',
      data: form
    })
  },

  fetchSlipShareRows: (params) =>
    axios({
      url: `/slip-share/rows/`,
      method: 'GET',
      params: params
    }),

  // responseType blob, or axios decodes the xlsx as text and corrupts it.
  // params carries the table's active filters, so the file matches the screen.
  downloadSlipShareTemplate: (params = {}) =>
    axios({
      url: `/slip-share/template/`,
      method: 'GET',
      params: params,
      responseType: 'blob'
    }),

  // No params: this is a fixed, blank column layout, not a view over
  // existing rows, so there is nothing to filter.
  downloadFcpBinderSplitsTemplate: () =>
    axios({
      url: `/slip-share/fcp-template/`,
      method: 'GET',
      responseType: 'blob'
    }),

  updateBillingType: (companyId, { scheme, enabled, startDate }, options = {}) =>
    axios({
      ...options,
      url: `/company/${companyId}/billing-type/update/`,
      method: 'POST',
      data: {
        scheme: scheme,
        enabled: enabled,
        start_date: startDate || null,
      }
    }),
}
